module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "orna1"
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007List_of_Illustrations"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/008Preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/009Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0101_The_Expedition_to_Jerusalem"
    }
  }, [_vm._v("1 The Expedition to Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0112_Syria_and_Palestine"
    }
  }, [_vm._v("2 Syria and Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0123_The_First_Settlers"
    }
  }, [_vm._v("3 The First Settlers")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0134_The_Origins_of_the_Latin_States",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Origins of the Latin States")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0145_The_Military_Institutional_and_Ecclesiastical_Framework",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Military, Institutional and Ecclesiastical Framework")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0156_Antioch_and_Jerusalem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Antioch and Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0167_The_Second_Generation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Second Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0178_The_Zengid_Threat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Zengid Threat")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/0189_The_Frankish_Imprint",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Frankish Imprint")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/01910_King_Amalric",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 King Amalric")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/02011_The_Disintegration_of_the_Crusader_States",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Disintegration of the Crusader States")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/02112_The_Battle_of_Hattin_and_its_Consequences",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 The Battle of Hattin and its Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/02213_The_Third_Crusade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The Third Crusade")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/023Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/024Chronology",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/025Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/027Further_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/028Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/029Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fa256e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006Contents.vue
// module id = 69
// module chunks = 0